import { FC } from "react";
import { getJourneyCardHeight } from "./utils";
import { JourenyCard } from "..";
import { JOURNEY_CARD_LISTING_GAP_DESKTOP,JOURNEY_CARD_LISTING_GAP_MOBILE, JOURNEY_LIST_WINDOW_SIZE, JourneyType } from "src/Modules/Flights/constants";
import { useVirtualScroll } from "src/hooks/useVirtualScroll";
import { getValue } from "src/utility";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { Grid } from "antd";

const JourneyList: FC<{ journies: JourneyType[] }> = ({ journies }) => {
  const screens = Grid.useBreakpoint();
  const isLargeScreen = !!screens[MOBILE_BREAKPOINT_KEY];

  const isReturn =
    getValue(journies, [0, "segments"], []).length > 1;

  const journeyCardHeight = getJourneyCardHeight({
    isLargeScreen,
    isReturn,
  });
  const GAP = isLargeScreen ? JOURNEY_CARD_LISTING_GAP_DESKTOP : JOURNEY_CARD_LISTING_GAP_MOBILE;

  const { listRef, visibleItems, startIndex, totalHeight } =
    useVirtualScroll({
      items: journies,
      itemHeight: journeyCardHeight,
      windowSize: JOURNEY_LIST_WINDOW_SIZE,
    });

  return (
    <div ref={listRef} className="relative w-full">
      <div style={{ position: "relative", height: totalHeight }}>
        {visibleItems?.map((item, i) => {
          const index = startIndex + i;
          const top = index * journeyCardHeight;
          return (
            <div
              key={index}
              style={{ position: "absolute", top, height:journeyCardHeight-GAP }}
              className="flex w-full items-center justify-center"
              
            >
              <JourenyCard
                journeyData={item}
                className="w-full h-full"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default JourneyList;